"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedTree = void 0;
const lodash_1 = __importDefault(require("lodash"));
const mobx_1 = require("mobx");
const enums_1 = require("../types/enums");
const consts_1 = require("../consts");
const FIXED_EXPENSE_ENVELOPE_TYPES = [
    enums_1.EnvelopeType.Fixed,
    enums_1.EnvelopeType.RollingCredit,
];
function getCategories(envelopes) {
    return lodash_1.default.chain(envelopes)
        .groupBy(e => e.details.expense || consts_1.DEFAULT_FIXED_EXPENSE_CATEGORY)
        .mapValues((categoryEnvelopes, expense) => ({
        expense,
        predictedAmount: lodash_1.default.sumBy(categoryEnvelopes, e => e.predictedAmount),
        balancedAmount: lodash_1.default.sumBy(categoryEnvelopes, e => e.balancedAmount),
        actualsAmount: lodash_1.default.sumBy(categoryEnvelopes, e => e.actualsAmount),
        envelopes: lodash_1.default.map(categoryEnvelopes, e => e.toJson()),
    }))
        .value();
}
function _getNormalizedExpenseCategory(envelope) {
    return envelope.details.expense || consts_1.DEFAULT_FIXED_EXPENSE_CATEGORY;
}
function _normalizeExpenseCategories(envelopes) {
    lodash_1.default.forEach(envelopes, envelope => {
        if (envelope.details) {
            envelope.details.expense = _getNormalizedExpenseCategory(envelope); // eslint-disable-line no-param-reassign
        }
    });
    return envelopes;
}
function _isFixedSavingEnvelope(e) {
    return ['לחסכון', 'השקעה וחיסכון'].includes(e.details.expense);
}
function _isFixedExpenseEnvelope(e) {
    return lodash_1.default.includes(FIXED_EXPENSE_ENVELOPE_TYPES, e.type) && e.isExpense;
}
class FixedTree {
    constructor(envelopes) {
        this.envelopes = _normalizeExpenseCategories(envelopes);
    }
    get fixedExpenseEnvelopes() {
        return lodash_1.default.chain(this.envelopes).filter(_isFixedExpenseEnvelope).reject(_isFixedSavingEnvelope).value();
    }
    get fixedIncomeEnvelopes() {
        return lodash_1.default.filter(this.envelopes, e => e.type === enums_1.EnvelopeType.Fixed && !e.isExpense);
    }
    get fixedSavingEnvelopes() {
        return lodash_1.default.chain(this.envelopes).filter(_isFixedExpenseEnvelope).filter(_isFixedSavingEnvelope).value();
    }
    get rollingCreditEnvelope() {
        return lodash_1.default.filter(this.envelopes, e => e.type === enums_1.EnvelopeType.RollingCredit);
    }
    get fixedExpenseEnvelopesPredictedSum() {
        return lodash_1.default.sumBy(this.fixedExpenseEnvelopes, e => e.predictedAmount);
    }
    get fixedExpenseEnvelopesBalanceSum() {
        return lodash_1.default.sumBy(this.fixedExpenseEnvelopes, e => e.balancedAmount);
    }
    get fixedExpenseEnvelopesActualSum() {
        return lodash_1.default.sumBy(this.fixedExpenseEnvelopes, e => e.actualsAmount);
    }
    get fixedIncomeEnvelopesPredictedSum() {
        return lodash_1.default.sumBy(this.fixedIncomeEnvelopes, e => e.predictedAmount);
    }
    get fixedIncomeEnvelopesBalanceSum() {
        return lodash_1.default.sumBy(this.fixedIncomeEnvelopes, e => e.balancedAmount);
    }
    get fixedIncomeEnvelopesActualSum() {
        return lodash_1.default.sumBy(this.fixedIncomeEnvelopes, e => e.actualsAmount);
    }
    get fixedSavingEnvelopesPredictedSum() {
        return lodash_1.default.sumBy(this.fixedSavingEnvelopes, e => e.predictedAmount);
    }
    get fixedSavingEnvelopesBalanceSum() {
        return lodash_1.default.sumBy(this.fixedSavingEnvelopes, e => e.balancedAmount);
    }
    get fixedSavingEnvelopesActualSum() {
        return lodash_1.default.sumBy(this.fixedSavingEnvelopes, e => e.actualsAmount);
    }
    get expenseCategories() {
        return getCategories(this.fixedExpenseEnvelopes);
    }
    get incomeCategories() {
        return getCategories(this.fixedIncomeEnvelopes);
    }
    get savingCategories() {
        return getCategories(this.fixedSavingEnvelopes);
    }
}
__decorate([
    mobx_1.observable
], FixedTree.prototype, "envelopes", void 0);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedExpenseEnvelopes", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedIncomeEnvelopes", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedSavingEnvelopes", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "rollingCreditEnvelope", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedExpenseEnvelopesPredictedSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedExpenseEnvelopesBalanceSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedExpenseEnvelopesActualSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedIncomeEnvelopesPredictedSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedIncomeEnvelopesBalanceSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedIncomeEnvelopesActualSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedSavingEnvelopesPredictedSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedSavingEnvelopesBalanceSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "fixedSavingEnvelopesActualSum", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "expenseCategories", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "incomeCategories", null);
__decorate([
    mobx_1.computed
], FixedTree.prototype, "savingCategories", null);
exports.FixedTree = FixedTree;
//# sourceMappingURL=fixed-tree.js.map